export default {"src":"https://images-cdn-staging.curipod.com/d-5f0b73e4/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};